import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: 'bold'
  },
  labelPosition: {
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    color: '#6b6a6a',
    gap: 4,
    marginBottom: 4,
    fontSize: 12
  },
  table: {
    minWidth: 300,
    '& .MuiTableCell-root': {
      padding: '4px 8px'
    }
  },
  smallInput: {
    '& .MuiInputBase-root': {
      fontSize: '12px',
      padding: '4px'
    }
  },
  iconButton: {
    padding: '4px'
  },
  fieldset: {
    borderRadius: '20px',
    color: '#1976d2',
    marginTop: '6px',
    overflowX: 'auto',
    padding: '10px',
    maxWidth: '94vw',
    // width: '100%',
    backgroundColor: '#ffffff',
    boxShadow: '0 8px 20px rgba(15, 23, 42, 0.05)',
    border: '1px solid #d7e1f3',
    '& legend': {
      padding: '0 10px',
      color: '#1976d2',
      letterSpacing: '0.2px'
    }
  },
  dialogPaper: {
    borderRadius: 18,
    background: 'linear-gradient(135deg, #f7faff 0%, #ffffff 55%, #eef3ff 100%)',
    boxShadow: '0 18px 36px rgba(25, 118, 210, 0.22)',
    // width: '500vw!important',
    maxWidth: 'none',
    // minWidth: 320,
    '@media (max-width: 900px)': {
      width: '94vw'
    }
  },
  dialogPaperCompact: {
    borderRadius: 16,
    border: '1px solid #c7d2fe',
    background: 'linear-gradient(135deg, #ffffff 0%, #f6f8ff 100%)',
    boxShadow: '0 14px 28px rgba(30, 64, 175, 0.18)'
  },
  dialogTitle: {
    color: '#ffffff',
    fontWeight: 700,
    letterSpacing: 0.4,
    padding: theme.spacing(2, 3)
  },
  dialogContent: {
    backgroundColor: '#fbfcff',
    padding: theme.spacing(2.5, 3)
  },
  dialogText: {
    color: '#1f2937',
    fontWeight: 500
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    borderTop: '1px solid #d8e2f0',
    justifyContent: 'space-between'
  },
  actionButton: {
    fontWeight: 700,
    textTransform: 'none',
    borderRadius: 10,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  },
  formArea: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'rgba(248, 251, 255, 0.3)',
      borderRadius: 12,
      transition: 'box-shadow 0.2s ease, border-color 0.2s ease'
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: '#dee5ecbb'
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1e88e5'
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1e40af',
      boxShadow: '0 0 0 3px rgba(30, 64, 175, 0.12)'
    },
    '& .MuiInputBase-input': {
      padding: '10px 12px',
      fontSize: 13.5
    },
    '& .MuiInputLabel-root': {
      color: '#4b5563'
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#1e40af'
    },
    '& $labelPosition': {
      padding: '4px 8px',
      color: '#1e3a8a'
    }
  }
}));

export default useStyles;
